'use client';
import { createStyles, unit } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var useStyles = createStyles((theme, { shadow, radius })=>{
    const pixelRadius = unit(theme.fn.borderRadius(radius));
    return {
        dropdown: _extends({
            boxSizing: 'border-box',
            position: 'absolute',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch'
        }, shadow && {
            boxShadow: theme.shadows[shadow] || shadow
        }, {
            borderRadius: pixelRadius,
            '&:focus': {
                outline: 0
            }
        }),
        content: {
            backgroundColor: theme.palette.background.content2,
            padding: theme.fn.space('2s 3s'),
            borderRadius: pixelRadius,
            position: 'relative',
            zIndex: 1
        },
        header: {
            padding: theme.fn.space('2s 2s 6s'),
            marginBottom: -pixelRadius,
            background: theme.palette.background.highlight,
            borderRadius: theme.fn.borderRadius('1.5r 1.5r 0 0')
        },
        footer: {
            padding: theme.fn.space('6s 2s 2s'),
            marginTop: -pixelRadius,
            background: theme.palette.background.highlight,
            borderRadius: theme.fn.borderRadius('0 0 1.5r 1.5r')
        },
        arrow: {
            backgroundColor: theme.palette.background.content2,
            zIndex: 1
        }
    };
});

export { useStyles as default };
//# sourceMappingURL=PopoverDropdown.styles.js.map
